/** A row whose queued change has not synced back to the server yet. */
export type PendingSync<T> = T & {pendingSync?: boolean};

/** True when a snapshot row carries a queued, not-yet-synced change. */
export const isPendingSync = (row: unknown): boolean =>
  (row as {pendingSync?: boolean} | undefined)?.pendingSync === true;
